import React, { Fragment } from 'react'
import {
  List,
  Datagrid,
  TextField,
  TextInput,
  SimpleForm,
  Edit,
  SelectInput,
  AutocompleteInput,
  ReferenceInput,
  Filter,
  ListButton,
  ReferenceField,
  DateField,
  FormDataConsumer,
  required,
  CardActions,
  SearchInput,
  AutocompleteArrayInput,
  ReferenceArrayInput,
  BooleanInput
} from 'react-admin'

import { teacherRoles, userTypeOptions } from '../../utils/enum'
import EditPasswordAction from './actions/EditPasswordAction'
import UserListActions from './actions/UserListActions'

const filterClassBySchool = (schoolId) => {
  if (schoolId) {
    return {
      schoolId: schoolId
    }
  }
  return {}
}

const User = {
  actions: ({ basePath, data }) => (
    <CardActions>
      <ListButton basePath={basePath} />
      <EditPasswordAction record={data} />
    </CardActions>
  ),
  filter: (props) => (
    <Filter {...props}>
      <SearchInput source='username' label='Search by username' alwaysOn />
      <SelectInput source='type' label='Type' choices={userTypeOptions} alwaysOn />
      <SearchInput source='email' label='Search by email' />
      <SelectInput source='role' choices={teacherRoles} />

      <ReferenceInput
        label='School'
        source='schoolId'
        reference='school'
        allowEmpty
        filterToQuery={searchText => ({ name: {$regex: searchText, $options: 'i'} })}
      >
        <AutocompleteInput optionText='name' translateChoice={false} />
      </ReferenceInput>

      <ReferenceInput
        label='Class'
        source='classId'
        reference='class'
        allowEmpty
        filterToQuery={searchText => ({name: {$regex: searchText, $options: 'i'}})}
      >
        <AutocompleteInput optionText='name' translateChoice={false} />
      </ReferenceInput>
    </Filter>
  ),
  edit: (props) => {
    return (
      <Edit title='Edit User' actions={<User.actions />} {...props}>
        <SimpleForm>
          <TextField label='id' source='id' />
          <TextInput source='username' label='Username' validate={required()} />
          <ReferenceArrayInput
            label='Apps'
            source='appIds'
            reference='app'
            allowEmpty
            filterToQuery={searchText => ({ name: {$regex: searchText} })}
          >
            <AutocompleteArrayInput optionText='name' translateChoice={false} validate={required()} allowEmpty />
          </ReferenceArrayInput>
          <TextInput source='firstname' label='First name' />
          <TextInput source='lastname' label='Last name' />
          <BooleanInput source='passwordReset' />
          <BooleanInput source='requirePasswordReset' />
          <SelectInput source='type' label='Type' choices={userTypeOptions} allowEmpty helperText='Can not change after setting once.' />

          <FormDataConsumer>
            {({ formData, ...rest }) => {
              if (formData.type === 'student') {
                return (
                  <Fragment>
                    {console.log('formData', formData)}
                    <ReferenceInput
                      label='School'
                      source='schoolId'
                      reference='school'
                      allowEmpty
                      validate={required()}
                      filterToQuery={searchText => ({ name: {$regex: searchText, $options: 'i'} })}
                      {...rest}
                    >
                      <AutocompleteInput optionText='name' translateChoice={false} />
                    </ReferenceInput>
                    <ReferenceInput
                      label='Class'
                      source='classId'
                      reference='class'
                      allowEmpty
                      validate={required()}
                      filter={filterClassBySchool(formData.schoolId)}
                      filterToQuery={searchText => ({ name: {$regex: searchText, $options: 'i'} })}
                      {...rest}
                    >
                      <AutocompleteInput optionText='name' translateChoice={false} />
                    </ReferenceInput>
                  </Fragment>
                )
              }
            }}
          </FormDataConsumer>

          <FormDataConsumer>
            {({ formData, ...rest }) => {
              if (formData.type === 'teacher') {
                return (
                  <Fragment>
                    <div><TextInput source='email' type='email' validate={required()} {...rest} /></div>
                    <SelectInput
                      source='role'
                      choices={teacherRoles}
                      allowEmpty
                      {...rest}
                    />
                    <ReferenceInput
                      label='School'
                      source='schoolId'
                      reference='school'
                      allowEmpty
                      filterToQuery={searchText => ({ name: {$regex: searchText, $options: 'i'} })}
                      {...rest}
                    >
                      <AutocompleteInput optionText='name' translateChoice={false} />
                    </ReferenceInput>
                  </Fragment>
                )
              }
            }}
          </FormDataConsumer>

          <FormDataConsumer>
            {({ formData, ...rest }) => {
              if (formData.type === 'individual') {
                return (
                  <TextInput source='email' type='email' validate={required()} {...rest} />
                )
              }
            }}
          </FormDataConsumer>

          <DateField source='createdAt' showTime />
          <DateField source='updatedAt' showTime />
        </SimpleForm>
      </Edit>
    )
  },
  list: (props) => (
    <List filters={<User.filter />} actions={<UserListActions />} title='Users' {...props}>
      <Datagrid
        rowClick='edit'
      >
        <TextField source='type' label='Type' />
        <TextField source='username' label='Username' />
        <TextField source='email' label='Email' />
        <TextField source='role' label='Role' />
        <ReferenceField label='School' source='schoolId' reference='school' allowEmpty>
          <TextField source='name' />
        </ReferenceField>
        <ReferenceField label='Class' source='classId' reference='class' allowEmpty>
          <TextField source='name' />
        </ReferenceField>
        <DateField source='createdAt' />
        <DateField source='updatedAt' />
      </Datagrid>
    </List>
  )
}

export default User
